import { useState } from 'react';
import config from '../../../config';

export const useProductCSVApproveMutation = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    const mutate = async (file) => {
        setIsLoading(true);
        setError(null);
        setData(null);

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch(`${config.serverUrl}/sessions/approve-csv`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => null);
                throw new Error(errorData?.detail || `HTTP error! status: ${response.status}`);
            }

            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let finalData = null;

            while (true) {
                const { done, value } = await reader.read();

                if (done) {
                    break;
                }

                buffer += decoder.decode(value, { stream: true });

                const parts = buffer.split('\n\n');

                buffer = parts.pop();

                for (const part of parts) {
                    if (part.startsWith('data: ')) {
                        const jsonStr = part.substring(6);

                        try {
                            const parsedData = JSON.parse(jsonStr);
                            setData(parsedData);
                            finalData = parsedData;
                        } catch (e) {
                            console.error('Error parsing data chunk:', e);
                        }
                    }
                }
            }

            return finalData;

        } catch (err) {
            const errorMessage = err.message || 'An error occurred during upload';
            setError(errorMessage);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return { mutate, isLoading, error, data };
};